export default function interpolate(str: string, payload: Record<string, unknown>) {
  return Object.keys(payload).reduce((s, key) => (s ?? '').split(`{${key}}`).join(String(payload[key])), str);
}
